module.exports = __webpack_public_path__ + "img/device_desk.5e6af429.png";